import { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type ViewSuggestedPlacesEventArgs = {
  query: string
  count: number | null
  sessionToken: string
  screen: string
}

export const viewSuggestedPlacesEvent = (args: ViewSuggestedPlacesEventArgs): TrackingEvent => {
  const { query, count, sessionToken, screen } = args

  return {
    event: 'user.autocomplete_results',
    extra: {
      query,
      count,
      session_token: sessionToken,
      screen,
    },
  }
}

type SelectSuggestedPlaceEventArgs = {
  selectedAutocomplete: string
  sessionToken: string
  screen: string
}

export const selectSuggestedPlaceEvent = (args: SelectSuggestedPlaceEventArgs): TrackingEvent => {
  const { selectedAutocomplete, sessionToken, screen } = args

  return {
    event: 'user.autocomplete_details',
    extra: {
      selected_autocomplete: selectedAutocomplete,
      session_token: sessionToken,
      screen,
    },
  }
}
